module.exports = __webpack_public_path__ + "img/mediator-diplomat-1.54285e62.svg";